"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { ADMIN_PATH, LEGACY_ADMIN_PATH } from "@/lib/app-routes";

const AiChat = dynamic(() => import("./AiChat"), {
  ssr: false,
  loading: () => <AiChatLauncher loading onOpen={() => {}} />,
});

function SparkleIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2l2.4 6.6L21 11l-6.6 2.4L12 20l-2.4-6.6L3 11l6.6-2.4L12 2z" fill="currentColor" />
    </svg>
  );
}

function AiChatLauncher({ loading = false, onOpen }: { loading?: boolean; onOpen: () => void }) {
  return (
    <div
      className="fixed bottom-5 z-50"
      style={{
        left: "calc(var(--sidebar-w, 220px) + (100vw - var(--sidebar-w, 220px)) / 2)",
        transform: "translateX(-50%)",
        width: "min(700px, calc(100vw - 32px))",
      }}
    >
      <button
        type="button"
        onClick={onOpen}
        disabled={loading}
        className="w-full flex items-center gap-3 px-5 py-3 rounded-[22px] shadow-lg border border-gray-200 bg-white text-left disabled:cursor-wait"
      >
        <span className="text-indigo-500 shrink-0"><SparkleIcon className="w-5 h-5" /></span>
        <span className="flex-1 text-sm text-gray-400">Спроси что-нибудь про магазин...</span>
        <span className="text-[11px] text-gray-400 shrink-0">{loading ? "Открываю..." : "Открыть"}</span>
      </button>
    </div>
  );
}

export default function AiChatDynamic() {
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);
  const [initialOpen, setInitialOpen] = useState(false);
  // Где ИИ-чат (и его лаунчер «Спроси что-нибудь...») не показываем.
  const HIDE_ON = ["/login", "/register", "/ab-tests", "/product-groups", ADMIN_PATH, LEGACY_ADMIN_PATH, "/settings", "/supply-pult"];
  const isHiddenPath = pathname === "/cost" || HIDE_ON.some(p => pathname.startsWith(p));

  const openChat = () => {
    setInitialOpen(true);
    setMounted(true);
  };

  if (isHiddenPath) return null;
  if (!mounted) return <AiChatLauncher onOpen={openChat} />;

  return <AiChat initialOpen={initialOpen} />;
}
